import { Directive } from '@angular/core';
@Directive({
  selector: '[fEntityContainer]',
  standalone: false
})
export class EntityContainerDirective {}
